import { Link } from '@reach/router';
import React, { Component } from 'react';
import BackArrow from '../SvgElements/BackArrow';
import Button from '../SvgElements/Button';
import moment from 'moment';
import RightArrow from '../SvgElements/RightArrow';
import CheckoutForm from './CheckoutForm';
import Payment from '../CommerceComponents/Payment';
import ShippingMethod from '../CommerceComponents/ShippingMethod';
import Info from '../CommerceComponents/Info';

function formatNumber(num) {
    if(num.length>6){
        const middle=num.substring(3,6)
        const latter=num.substring(6,10)
        const beg=num.substring(0,3)
        return ("("+beg+") "+middle+"-"+latter)
    }
    return(num)
}

const Stripe = require('stripe');
const stripe = Stripe('sk_test_4eC39HqLyjWDarjtT1zdp7dc');


const StepInfo=(props)=>{
    let estDate=moment().add(props.userPack.elements.order.deliveryMethod.estDeliveryEarly,'days').format('LL')
    const goToMain=()=>{
        props.userPack.refs.routeLandingRef.current.click()
    }
    // const popUpQuantity=(e)=>{
    //     // console.log("test 1",e.target.id)
    //     e.stopPropagation()
    //     e.preventDefault()
    //     let neoModal={...props.userPack.modal}
    //     neoModal.open=true
    //     neoModal.type="quantity"
    //     neoModal.productId="1"
    //     props.userPack.methods.stateHandling('modal',neoModal)
    // }
    const popUpDeliveryMethod=(e)=>{
        // console.log("test 1",e.target.id)
        e.stopPropagation()
        e.preventDefault()
        let neoModal={...props.userPack.modal}
        neoModal.open=true
        neoModal.type="deliveryMethod"
        neoModal.productId="1"
        props.userPack.methods.stateHandling('modal',neoModal)
    }
    const [expandedOrder,setExpandedOrder]=React.useState(false)
    const qloq = ()=>{
        return(
            <div className="body1">qloq</div>
        )
    }
    let myString=""
    for (let index = 0; index < 1000; index++) {
        myString=myString+qloq()
        
    }
    const expandOrder=()=>{
        setExpandedOrder(prev=>!prev)
    }
    const goInfo=()=>{
        props.setStep(1)
    }
    const goShip=()=>{
        props.setStep(2)
    }
    const goPay=()=>{
        props.setStep(3)
    }
    const [checkoutData,setCheckoutData]=React.useState({keepUpdated:true,useSameShipping:true})
    const handleEmail=(e)=>{
        let neoOrder ={...props.userPack.order}
        neoOrder.userName=e.target.value
        props.userPack.methods.stateHandling('order',neoOrder)
    }
    const [applyLoading,setApplyLoading]=React.useState(false)

    const handleApply = (e)=>{
        e.preventDefault()
        e.stopPropagation()
        setApplyLoading(prev=>!prev)
    }
    const logout=()=>{
        props.userPack.methods.logout()
    }
    const popUpQuantity=(e)=>{
        // console.log("test 1",e.target.id)
        e.stopPropagation()
        e.preventDefault()
        let neoModal={...props.userPack.modal}
        neoModal.open=true
        neoModal.type="quantity"
        neoModal.productId="1"
        props.userPack.methods.stateHandling('modal',neoModal)
    }
    const handleCheckoutData=(e)=>{
        let eventValue = e.target.value
        const eventName = e.target.name
        let neoShippingInfo ={...props.userPack.shippingInfo}
        
        if (eventName=="useAccountName"||eventName=="keepUpdated"||eventName=="useSameShipping"){
            neoShippingInfo[eventName]=!neoShippingInfo[eventName]
            window.localStorage.setItem(eventName,eventValue)
            props.userPack.methods.stateHandling('shippingInfo',neoShippingInfo)
            return
        }
        console.log(e.target.name,"el nombre",eventValue)
        if(eventName==="phoneNumber"||eventName==="zipcode"){
            eventValue=eventValue.replace(/\D/g, '')
            neoShippingInfo[eventName]=eventValue
            window.localStorage.setItem(eventName,eventValue)
            props.userPack.methods.stateHandling('shippingInfo',neoShippingInfo)
            return
        }
        
        neoShippingInfo[eventName]=eventValue
        window.localStorage.setItem(eventName,eventValue)
        console.log("done",eventValue)
        props.userPack.methods.stateHandling('shippingInfo',neoShippingInfo)
    }
    let value="340px"
    let totalito=0
    props.userPack.order.selectionList.map((c,index)=>{totalito+=c.price*c.quantity})
    totalito=Math.round(totalito*100)/100
    return(
        <>
                        {props.userPack.dimensions.width<750?
                                               <div className="wide alignCenter">
                                               <div className="wide" style={{maxWidth:"545px"}}>
                <div className="wide l4 t4"><div style={{maxWidth:"100px"}} className="title2 button" onClick={goToMain}>LeanTech</div>
                </div>
                </div>
                </div>
                :null}
                            <div className={props.userPack.dimensions.width>750?"wide":"wide t3"}>
            {props.userPack.dimensions.width<750?
            
                    <div className="wide t4 whiteColonial button" onClick={expandOrder} id="orderRow" style={{position:"relative !important",borderTop:"1px solid rgb(230, 230, 230)",borderBottom:"1px solid rgb(230, 230, 230)",paddingTop:"15px",paddingBottom:"0px",paddingLeft:"2px"}}>
                       <div className="wide alignCenter">
                        <div className="wide" style={{maxWidth:"545px"}}>
                            
                       
                        <div className="checkoutLine">
                        <div className="flexStart l2">
                        <svg width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.5317 15.0799H7.99316L8.72314 13.7715L20.852 13.7521C21.2622 13.7521 21.6138 13.4943 21.687 13.1377L23.3667 4.86406C23.4106 4.64707 23.3447 4.42363 23.1836 4.25391C23.1039 4.17038 23.0046 4.10309 22.8925 4.05672C22.7803 4.01034 22.6581 3.98599 22.5342 3.98535L7.10449 3.94023L6.97266 3.39453C6.88965 3.04648 6.5332 2.79297 6.12793 2.79297H2.35596C2.12739 2.79297 1.90818 2.87287 1.74656 3.0151C1.58494 3.15733 1.49414 3.35023 1.49414 3.55137C1.49414 3.75251 1.58494 3.94541 1.74656 4.08764C1.90818 4.22986 2.12739 4.30977 2.35596 4.30977H5.42969L6.00586 6.72031L7.42432 12.7639L5.59814 15.3871C5.50331 15.4997 5.44619 15.6335 5.43324 15.7732C5.4203 15.9129 5.45205 16.0531 5.5249 16.1777C5.67139 16.4334 5.9668 16.5945 6.29394 16.5945H7.82715C7.50029 16.9766 7.32374 17.4419 7.32422 17.9201C7.32422 19.1361 8.44726 20.1244 9.8291 20.1244C11.2109 20.1244 12.334 19.1361 12.334 17.9201C12.334 17.441 12.1533 16.9748 11.8311 16.5945H15.7642C15.4373 16.9766 15.2607 17.4419 15.2612 17.9201C15.2612 19.1361 16.3843 20.1244 17.7661 20.1244C19.1479 20.1244 20.271 19.1361 20.271 17.9201C20.271 17.441 20.0903 16.9748 19.7681 16.5945H22.5342C23.0078 16.5945 23.396 16.2551 23.396 15.8361C23.3946 15.6352 23.3029 15.4429 23.141 15.3012C22.9791 15.1596 22.7601 15.08 22.5317 15.0799V15.0799ZM7.46338 5.43555L21.521 5.47637L20.144 12.2611L9.10156 12.2783L7.46338 5.43555ZM9.8291 18.599C9.40429 18.599 9.05762 18.2939 9.05762 17.9201C9.05762 17.5463 9.40429 17.2412 9.8291 17.2412C10.2539 17.2412 10.6006 17.5463 10.6006 17.9201C10.6006 18.1002 10.5193 18.2729 10.3746 18.4002C10.2299 18.5275 10.0337 18.599 9.8291 18.599V18.599ZM17.7661 18.599C17.3413 18.599 16.9946 18.2939 16.9946 17.9201C16.9946 17.5463 17.3413 17.2412 17.7661 17.2412C18.1909 17.2412 18.5376 17.5463 18.5376 17.9201C18.5376 18.1002 18.4563 18.2729 18.3116 18.4002C18.1669 18.5275 17.9707 18.599 17.7661 18.599V18.599Z" fill="black"/>
                        </svg>
                        <div className={props.userPack.dimensions.width<386?"body2 l2":"body1 l2"} style={{minWidth:"140px"}}>{expandedOrder?"Hide":"Show"} order summary</div>
                    <div className={expandedOrder?"l1 rotate":"l1"} style={{position:"relative",top:"3px"}}>
                        <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.4583 8.05126C13.4587 8.16953 13.4353 8.28639 13.39 8.39325C13.3446 8.50011 13.2784 8.59425 13.1962 8.66876L8.94624 12.4925C8.8195 12.609 8.66052 12.6726 8.49645 12.6726C8.33238 12.6726 8.1734 12.609 8.04666 12.4925L3.79666 8.53418C3.652 8.3998 3.56104 8.20671 3.54377 7.99737C3.5265 7.78803 3.58434 7.5796 3.70457 7.41793C3.82481 7.25626 3.99758 7.15459 4.18488 7.13529C4.37218 7.11599 4.55867 7.18064 4.70333 7.31501L8.49999 10.8538L12.2967 7.43376C12.4006 7.33696 12.5272 7.27546 12.6615 7.25656C12.7958 7.23765 12.9321 7.26213 13.0543 7.32709C13.1765 7.39205 13.2795 7.49478 13.3511 7.62311C13.4227 7.75145 13.4599 7.90003 13.4583 8.05126Z" fill="black"/>
                        </svg>
                    </div>
                    </div>
                    <div className="flexEnd r2"><div className="body1">${totalito + 5.00}</div></div>
                    
                    </div>
                    <div className="wide alignCenter t3"> <div className="hrFullElement"></div></div>
                    
                   
                    <div className="wide long alignCenter t4" style={{paddingLeft:"20px",paddingRight:"20px",paddingBottom:"20px"}}>
                    <div className="wide">
                        <div className="checkoutLine">
                            <div className="flexWrap">
                                <div className="relative">
                                <div style={{width:"64px",height:"64px",backgroundSize:"cover",backgroundImage:'url(https://leantech.shop/media/images/burn.png)'}}></div>
                                <div className="absolute" style={{position:"absolute",top:"-10px",right:"-10px",
                                borderRadius:"50%",backgroundColor:"rgba(114,114,114,0.9)",height:"20px",
                                width:"20px"}}>
                                    <div className="wide long relative alignCenter button" onClick={popUpQuantity}>
                                        <div className="body2 bold white">{props.userPack.order.selectionList[0].quantity}</div>
                                    </div>
                                </div>
                                </div>
                                <div className="long alignCenter">
                                    <div className="relative l3">
                                        <div className="body2 bold">Burn PM Night</div>
                                        <div className="body3 t1 grey1">Weight management</div>
                                    </div>
                                </div>
                               
                            </div>
                            <div className="flexEnd"><div className="body2 grey1">$34.99</div></div>
                        </div>


                            <div className="wide t3 b3">
                            <div className="hrFullElement"></div>
                            </div>
                            <div className="wide">
                                <div className="checkoutLine">
                                <div className="flexStart"><div className="body2 grey1">Subtotal</div></div>
                                    <div className="flexEnd"><div className="body2 grey1">${totalito}</div></div>
                                </div>
                                <div className="checkoutLine t2">
                                <div className="flexStart"><div className="body2 grey1">Shipping</div></div>
                                    <div className="flexEnd"><div className="body2 grey1">$5.00</div></div>
                                </div>
                            </div>
                            <div className="wide t3 b3">
                            <div className="hrFullElement"></div>
                            </div>
                            <div className="wide">
                                <div className="checkoutLine">
                                    <div className="flexStart"><div className="body1">Total</div></div>
                                    <div className="flexEnd"><div className="body3 grey r2">USD</div><div className="title1">${totalito+5.00}</div></div>
                                    
                                </div>
                            </div>
                            </div>
                </div>

                    </div>
                    </div>
                    </div>
                    :null}
                    </div>
                    
        <div className="wide" style={{transition:"all .1s ease",position:"absolute", top:props.userPack.dimensions.width<750?(!expandedOrder?"108px":value):"0px",zIndex:"9000",backgroundColor:"white"}}>  
        <div className="checkoutBody">
            <div className="wide alignCenter">
            <div className="wide leftPanel">
                {props.userPack.dimensions.width>750?
                <div className="wide t4"><div style={{maxWidth:"100px"}} className="title1 button" onClick={goToMain}>LeanTech</div></div>
                :null}
            


            <div className="flexStart t3 b3">
                {props.tabs.map((tab,index)=>(
                    <>
                                    <Link to={"/checkout/"+tab}>
                <div className={props.step==index+1?"body3 button":"body3 button grey1"} >{tab}</div></Link>
                <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.05126 3.54167C8.16953 3.54131 8.28639 3.56467 8.39325 3.61002C8.50011 3.65538 8.59425 3.72158 8.66876 3.80376L12.4925 8.05376C12.609 8.1805 12.6726 8.33948 12.6726 8.50355C12.6726 8.66762 12.609 8.8266 12.4925 8.95334L8.53418 13.2033C8.3998 13.348 8.20671 13.439 7.99737 13.4562C7.78803 13.4735 7.5796 13.4157 7.41793 13.2954C7.25626 13.1752 7.15459 13.0024 7.13529 12.8151C7.11599 12.6278 7.18064 12.4413 7.31501 12.2967L10.8538 8.50001L7.43376 4.70334C7.33696 4.59937 7.27546 4.47276 7.25656 4.3385C7.23765 4.20423 7.26213 4.06793 7.32709 3.94572C7.39205 3.82352 7.49478 3.72052 7.62311 3.64891C7.75145 3.57731 7.90003 3.54009 8.05126 3.54167Z" fill="black"/>
</svg>
                    </>
                ))}
                
            </div>
            {props.step==1?
            <Info tabs={props.tabs} logout={logout} handleEmail={handleEmail} checkoutData={checkoutData} handleCheckoutData={handleCheckoutData} userPack={props.userPack} goInfo={goInfo}/>
            :null}
            {props.step==3?<Payment elements={props.elements} stripe={props.stripe} tabs={props.tabs} handleCheckoutData={handleCheckoutData} userPack={props.userPack} goInfo={goInfo}/>:null}
            {props.step==2?
           <ShippingMethod userPack={props.userPack} tabs={props.tabs} goInfo={goInfo}/>
            :null}
            </div>
            </div>
            <div></div>
            <div className="shippingTotalPanel">
                <div className="wide long alignCenter" style={{paddingLeft:"2rem",paddingRight:"2rem",paddingBottom:"15vh"}}>
                    <div className="wide">
                        <div className="checkoutLine">
                            <div className="flexWrap">
                                <div className="relative">
                                <div style={{width:"64px",height:"64px",backgroundSize:"cover",backgroundImage:'url(https://leantech.shop/media/images/burn.png)'}}></div>
                                <div className="absolute" style={{position:"absolute",top:"-10px",right:"-10px",
                                borderRadius:"50%",backgroundColor:"rgba(114,114,114,0.9)",height:"20px",
                                width:"20px"}}>
                                    <div className="wide long relative alignCenter button" onClick={popUpQuantity}>
                                        <div className="body2 bold white">{props.userPack.order.selectionList[0].quantity}</div>
                                    </div>
                                </div>
                                </div>
                                <div className="long alignCenter">
                                    <div className="relative l3">
                                        <div className="body2 bold">Burn PM Night</div>
                                        <div className="body3 t1 grey1">Weight management</div>
                                    </div>
                                </div>
                               
                            </div>
                            <div className="flexEnd"><div className="body2 grey1">${totalito}</div></div>
                        </div>

                        <div className="wide t3 b3">
                            <div className="hrFullElement"></div>
                            </div>
                            <div className="" style={{display:"grid",gridTemplateColumns:"3fr 1fr",gridTemplateRows:"auto"}}>
                                <div className="wide r4 alignCenter">
                                    <div className="wide">
                                <div class="material-textfield">
                                    <input type="text" placeholder=" " style={{width:"100%"}}/>
                                    <label>Gift card or discount code</label>
                                </div>
                                </div>
                                </div>
                                    
                                <div className="wide l1">
                                    <Button loading={applyLoading} text="Apply" style="black" action={handleApply}/>
                                </div>

                                
                            </div>
                            <div className="wide t3 b3">
                            <div className="hrFullElement"></div>
                            </div>
                            <div className="wide">
                                <div className="checkoutLine">
                                <div className="flexStart"><div className="body2 grey1">Subtotal</div></div>
                                    <div className="flexEnd"><div className="body2 grey1">${totalito}</div></div>
                                </div>
                                <div className="checkoutLine t2">
                                <div className="flexStart"><div className="body2 grey1">Shipping</div></div>
                                    <div className="flexEnd"><div className="body2 grey1">$5.00</div></div>
                                </div>
                            </div>
                            <div className="wide t3 b3">
                            <div className="hrFullElement"></div>
                            </div>
                            <div className="wide">
                                <div className="checkoutLine">
                                    <div className="flexStart"><div className="body1">Total</div></div>
                                    <div className="flexEnd"><div className="body3 grey r2">USD</div><div className="title1">${totalito+5.00}</div></div>
                                    
                                </div>
                            </div>
                            </div>
                </div>
                    
                
            </div>
            </div>
            </div> 
        </>
    )
}
const StepDefault=(props)=>{
    let estDate=moment().add(props.userPack.elements.order.deliveryMethod.estDeliveryEarly,'days').format('LL')
    
    const popUpQuantity=(e)=>{
        // console.log("test 1",e.target.id)
        e.stopPropagation()
        e.preventDefault()
        let neoModal={...props.userPack.modal}
        neoModal.open=true
        neoModal.type="quantity"
        neoModal.productId="1"
        props.userPack.methods.stateHandling('modal',neoModal)
    }
    const popUpDeliveryMethod=(e)=>{
        // console.log("test 1",e.target.id)
        e.stopPropagation()
        e.preventDefault()
        let neoModal={...props.userPack.modal}
        neoModal.open=true
        neoModal.type="deliveryMethod"
        neoModal.productId="1"
        props.userPack.methods.stateHandling('modal',neoModal)
    }
    const checkout=()=>{
        stripe.charges.create({
            amount: 2000,
            currency: "usd",
            source: "tok_visa", // obtained with Stripe.js
            description: "My First Test Charge (created for API docs)"
          }, {
            idempotencyKey: "cnL0y8n2TGM3I2zG"
          }, function(err, charge) {
            // asynchronously called
            console.log("qloq",err,charge)
          });
    }
    return(
        <>
         <div className="navPlain">
            <BackArrow/>
            <div className="title2 alignCenter">Checkout</div>
            <div></div>
        </div>
        <div className="alignCenter">
            <div className="mainBody" style={{marginBottom:"110px"}}>
                <div className="wide alignCenter">
                    <div className="checkoutCard">
                        <div className="wide alignCenter">
                            <div className="checkoutPicture"></div>
                        </div>
                        <div className="wide" style={{padding:"15px"}}>
                            <div className="checkoutLine">
                                <div className="flexStart">
                                    <div className="body1">Night Burn PM</div>
                                </div>
                                
                                <div className="flexEnd"><div className="title3">$34.99</div></div>
                                
                            </div>
                            <div className="wide t2">
                                <div className="caption2 grey1">Size: 60 capsules</div>
                            </div>
                            <div className="wide t2">
                                <div className="body1 grey1">Quantity: <a className="button" onClick={popUpQuantity}>{props.userPack.elements.order.selectionList[0].quantity}</a></div>
                            </div>
                            <div className="wide">
                            <div className="checkoutLine t2 button" onClick={popUpDeliveryMethod}>
                                <div className="wide">
                                    <div className="wide">
                                        <div className="body1">Delivery options</div>
                                    </div>
                                    <div className="wide">
                                    <div className="body1">Est. delivery: {estDate}</div>
                                    </div>
                                    <div className="wide">
                                    <div className="body1">{props.userPack.elements.order.deliveryMethod.label}</div>
                                    </div>
                                    <div className="wide">
                                    <div className="body1">{props.userPack.elements.order.deliveryMethod.status}</div>
                                    </div>
                                </div>
                               <div className="flexEnd"><RightArrow/></div>
                                
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="wide t2">
                    <div className="checkoutLine t4">
                        <div className="body1 grey1">Add message to order</div>
                        <div className="flexEnd">
                            <RightArrow/>
                        </div>
                    </div>
                </div>
                <Link to="shippingInfo">
                <div className="wide t1">
                    <div className="checkoutLine t4">
                        <div className="checkoutInnerLine">
                            <div className="flexStart">
                            <div className="body1 grey1">Ship to</div>
                            </div>
                            <div className="col-md-8">
                            <div className="body1">{props.userPack.shippingInfo.fullName}</div>
                            <div className="body1 t1">{props.userPack.shippingInfo.address1}</div>
                            <div className="body1 t1">{props.userPack.shippingInfo.address1?props.userPack.shippingInfo.city+", "+props.userPack.shippingInfo.state+" "+props.userPack.shippingInfo.zipcode:""}</div>
                            <div className="body1 t1">{props.userPack.shippingInfo.phoneNumber?formatNumber(props.userPack.shippingInfo.phoneNumber):""}</div>
                            </div>
                        </div>
                        
                        <div className="flexEnd">
                            <RightArrow/>
                        </div>
                    </div>
                </div>
                </Link>

                <div className="wide t1">
                    <div className="checkoutLine t4">
                        <div className="">
                            <div className="flexStart">
                            <div className="body1 grey1">Gift cards or coupons</div>
                            </div>
                            <div className="col-md-8">
                            </div>
                        </div>
                        
                        <div className="flexEnd">
                            <RightArrow/>
                        </div>
                    </div>
                </div>
                {props.userPack.logged?
                <>
               
                <Link to="paymentOptions">
                <div className="wide t1">
                    <div className="checkoutLine t4">
                        <div className="checkoutInnerLine">
                            <div className="flexStart">
                            <div className="body1 grey1">Pay with</div>
                            </div>
                            <div className="col-md-8">
                                {props.userPack.shopData.paypal?
                                <>
                                <div className="flexStart">
                                                <svg width="67" height="45" viewBox="0 0 67 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.6645 22.793C21.6645 23.5156 21.4173 24.1162 20.923 24.5947C20.4286 25.0732 19.8228 25.3125 19.1055 25.3125C18.5433 25.3125 18.0925 25.1562 17.7533 24.8438C17.414 24.5312 17.2444 24.1016 17.2444 23.5547C17.2444 22.832 17.4867 22.2217 17.9714 21.7236C18.456 21.2256 19.057 20.9766 19.7743 20.9766C20.3171 20.9766 20.7679 21.1377 21.1265 21.46C21.4852 21.7822 21.6645 22.2266 21.6645 22.793ZM44.4922 18.4277C44.4922 19.248 44.2789 19.8047 43.8524 20.0977C43.4259 20.3906 42.7862 20.5371 41.9332 20.5371L41.0026 20.5664L41.497 17.4316C41.5357 17.2168 41.6617 17.1094 41.875 17.1094H42.3984C42.8249 17.1094 43.1642 17.1289 43.4162 17.168C43.6683 17.207 43.9106 17.3291 44.1432 17.5342C44.3759 17.7393 44.4922 18.0371 44.4922 18.4277ZM54.6992 22.793C54.6992 23.4961 54.452 24.0918 53.9577 24.5801C53.4633 25.0684 52.8672 25.3125 52.1693 25.3125C51.6071 25.3125 51.1515 25.1562 50.8025 24.8438C50.4536 24.5312 50.2791 24.1016 50.2791 23.5547C50.2791 22.832 50.5214 22.2217 51.0061 21.7236C51.4907 21.2256 52.0917 20.9766 52.809 20.9766C53.3519 20.9766 53.8026 21.1377 54.1612 21.46C54.5199 21.7822 54.6992 22.2266 54.6992 22.793ZM14.918 17.7832C14.918 16.6309 14.5448 15.7959 13.7984 15.2783C13.052 14.7607 12.0778 14.502 10.8759 14.502H6.22309C5.85475 14.502 5.65119 14.6875 5.61241 15.0586L3.72222 27.0117C3.70284 27.1289 3.73192 27.2363 3.80946 27.334C3.88701 27.4316 3.98394 27.4805 4.10026 27.4805H6.31033C6.69806 27.4805 6.91131 27.2949 6.95009 26.9238L7.47352 23.7012C7.49291 23.5449 7.56076 23.418 7.67708 23.3203C7.7934 23.2227 7.9388 23.1592 8.11328 23.1299C8.28776 23.1006 8.45255 23.0859 8.60764 23.0859C8.76273 23.0859 8.9469 23.0957 9.16016 23.1152C9.37341 23.1348 9.50911 23.1445 9.56727 23.1445C11.2345 23.1445 12.5431 22.6709 13.4931 21.7236C14.443 20.7764 14.918 19.4629 14.918 17.7832ZM23.9036 26.9238L25.0959 19.2773C25.1153 19.1602 25.0862 19.0527 25.0087 18.9551C24.9311 18.8574 24.8342 18.8086 24.7179 18.8086H22.5078C22.2364 18.8086 22.0716 19.1309 22.0135 19.7754C21.49 18.9941 20.5692 18.6035 19.2509 18.6035C17.855 18.6035 16.6676 19.1309 15.6886 20.1855C14.7096 21.2402 14.2201 22.4805 14.2201 23.9062C14.2201 25.0586 14.5545 25.9766 15.2233 26.6602C15.8921 27.3438 16.7888 27.6855 17.9132 27.6855C18.456 27.6855 19.0182 27.5684 19.5998 27.334C20.1814 27.0996 20.6467 26.7871 20.9957 26.3965C20.9181 26.6309 20.8793 26.8359 20.8793 27.0117C20.8793 27.3242 21.0054 27.4805 21.2574 27.4805H23.2639C23.6322 27.4805 23.8455 27.2949 23.9036 26.9238ZM36.9023 19.2188C36.9023 19.1211 36.8636 19.0283 36.786 18.9404C36.7085 18.8525 36.6212 18.8086 36.5243 18.8086H34.2852C34.0719 18.8086 33.8974 18.9062 33.7617 19.1016L30.6793 23.6719L29.3997 19.2773C29.3028 18.9648 29.0896 18.8086 28.76 18.8086H26.579C26.4821 18.8086 26.3948 18.8525 26.3173 18.9404C26.2397 19.0283 26.201 19.1211 26.201 19.2188C26.201 19.2578 26.39 19.834 26.768 20.9473C27.1461 22.0605 27.5532 23.2617 27.9894 24.5508C28.4256 25.8398 28.6534 26.5234 28.6727 26.6016C27.083 28.7891 26.2882 29.9609 26.2882 30.1172C26.2882 30.3711 26.4142 30.498 26.6662 30.498H28.9054C29.1186 30.498 29.2931 30.4004 29.4288 30.2051L36.8442 19.4238C36.883 19.3848 36.9023 19.3164 36.9023 19.2188ZM47.9527 17.7832C47.9527 16.6309 47.5795 15.7959 46.8331 15.2783C46.0867 14.7607 45.1126 14.502 43.9106 14.502H39.2869C38.8992 14.502 38.6859 14.6875 38.6471 15.0586L36.7569 27.0117C36.7376 27.1289 36.7666 27.2363 36.8442 27.334C36.9217 27.4316 37.0187 27.4805 37.135 27.4805H39.5195C39.7522 27.4805 39.9073 27.3535 39.9848 27.0996L40.5082 23.7012C40.5276 23.5449 40.5955 23.418 40.7118 23.3203C40.8281 23.2227 40.9735 23.1592 41.148 23.1299C41.3225 23.1006 41.4873 23.0859 41.6424 23.0859C41.7975 23.0859 41.9816 23.0957 42.1949 23.1152C42.4081 23.1348 42.5438 23.1445 42.602 23.1445C44.2692 23.1445 45.5778 22.6709 46.5278 21.7236C47.4777 20.7764 47.9527 19.4629 47.9527 17.7832ZM56.9384 26.9238L58.1306 19.2773C58.15 19.1602 58.1209 19.0527 58.0434 18.9551C57.9659 18.8574 57.8689 18.8086 57.7526 18.8086H55.5425C55.2711 18.8086 55.1063 19.1309 55.0482 19.7754C54.5441 18.9941 53.6233 18.6035 52.2856 18.6035C50.8898 18.6035 49.7023 19.1309 48.7233 20.1855C47.7443 21.2402 47.2548 22.4805 47.2548 23.9062C47.2548 25.0586 47.5892 25.9766 48.258 26.6602C48.9269 27.3438 49.8235 27.6855 50.9479 27.6855C51.5101 27.6855 52.082 27.5684 52.6636 27.334C53.2452 27.0996 53.7008 26.7871 54.0304 26.3965C54.0304 26.416 54.011 26.5039 53.9722 26.6602C53.9334 26.8164 53.9141 26.9336 53.9141 27.0117C53.9141 27.3242 54.0401 27.4805 54.2921 27.4805H56.2986C56.667 27.4805 56.8802 27.2949 56.9384 26.9238ZM63.2778 14.9414V14.9121C63.2778 14.6387 63.1518 14.502 62.8997 14.502H60.7478C60.5346 14.502 60.4086 14.6094 60.3698 14.8242L58.4796 27.0117L58.4505 27.0703C58.4505 27.168 58.4893 27.2607 58.5668 27.3486C58.6444 27.4365 58.7413 27.4805 58.8576 27.4805H60.7769C61.1453 27.4805 61.3488 27.2949 61.3876 26.9238L63.2778 14.9414ZM11.3993 18.8672C11.3024 19.5508 11.0503 20 10.6432 20.2148C10.2361 20.4297 9.65451 20.5371 8.89844 20.5371L7.9388 20.5664L8.43316 17.4316C8.47193 17.2168 8.59795 17.1094 8.8112 17.1094H9.36372C10.1392 17.1094 10.7014 17.2217 11.0503 17.4463C11.3993 17.6709 11.5156 18.1445 11.3993 18.8672ZM67 3.75V41.25C67 42.2656 66.6317 43.1445 65.895 43.8867C65.1583 44.6289 64.2859 45 63.2778 45H3.72222C2.71412 45 1.84172 44.6289 1.10503 43.8867C0.368345 43.1445 0 42.2656 0 41.25V3.75C0 2.73438 0.368345 1.85547 1.10503 1.11328C1.84172 0.371094 2.71412 0 3.72222 0H63.2778C64.2859 0 65.1583 0.371094 65.895 1.11328C66.6317 1.85547 67 2.73438 67 3.75Z" fill="black"/>
                    </svg>
                <div className="body1 l2">J***z@gmail.com</div>
        </div>
                            <div className="body1 t2">MASTER CARD x-0514</div>
                                </>
                                :
                                null
                                }
                    {props.userPack.elements.order&&props.userPack.elements.order.card?
                    <>
                                                    <div className="flexStart">
                                                    <svg width="41" height="26" viewBox="0 0 41 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="40" height="25" rx="3.5" fill="white" stroke="black"/>
<path d="M20.4809 10.8657C20.465 12.1145 21.6034 12.8113 22.461 13.2256C23.3422 13.6506 23.6381 13.9232 23.6346 14.3034C23.6281 14.8852 22.9318 15.1419 22.2803 15.1519C21.1435 15.1694 20.4826 14.8476 19.9571 14.6043L19.5476 16.504C20.0748 16.7448 21.051 16.9548 22.0632 16.9641C24.4394 16.9641 25.994 15.8012 26.0024 13.9983C26.0117 11.7101 22.81 11.5835 22.8318 10.5607C22.8394 10.2506 23.1379 9.91965 23.7919 9.83551C24.1157 9.793 25.0094 9.76047 26.0226 10.223L26.4203 8.3851C25.8754 8.1884 25.1751 8.00005 24.3031 8.00005C22.0666 8.00005 20.4936 9.17872 20.4809 10.8657ZM30.2417 8.15836C29.8078 8.15836 29.4421 8.40928 29.2789 8.79433L25.8847 16.8291H28.2591L28.7316 15.5345H31.6331L31.9072 16.8291H34L32.1738 8.15836H30.2417ZM30.5738 10.5006L31.2591 13.7566H29.3824L30.5738 10.5006ZM17.6021 8.15847L15.7304 16.8289H17.9931L19.8638 8.15825H17.6021V8.15847ZM14.2549 8.15825L11.8998 14.06L10.9471 9.04199C10.8354 8.48182 10.3939 8.15836 9.9037 8.15836H6.05392L6 8.41015C6.79034 8.58017 7.68831 8.8544 8.23234 9.14782C8.56528 9.32706 8.66022 9.48375 8.76959 9.90968L10.574 16.8291H12.965L16.6308 8.15836H14.2549" fill="url(#paint0_linear)"/>
<defs>
<linearGradient id="paint0_linear" x1="18.8727" y1="17.1439" x2="19.13" y2="7.93758" gradientUnits="userSpaceOnUse">
<stop stopColor="#222357"/>
<stop offset="1" stopColor="#254AA5"/>
</linearGradient>
</defs>
</svg>
                    {props.userPack.elements.order.card?
                    <div className="body1 l2">x-{props.userPack.elements.order.card.cardNumber.substring(props.userPack.elements.order.card.cardNumber.length-4,props.userPack.elements.order.card.cardNumber.length)}</div>
                    :null}
                
        </div>
                    </>
                    :null}
                            </div>
                        </div>
                        
                        <div className="flexEnd">
                            <RightArrow/>
                        </div>
                    </div>
                </div>
                </Link>
                </>:
                <div className="wide t4">
                  <CheckoutForm stripe={props.stripe} elements={props.elements} userPack={props.userPack}/></div>
                }
                <div className="wide">
                    <div className="checkoutLine t4">
                            <div className="body1 grey1">Subtotal</div>
                        <div className="flexEnd">
                        <div className="body1 grey1">${Math.round(34.99*props.userPack.elements.order.selectionList[0].quantity* 100) / 100}</div>
                        </div>
                    </div>
                    </div>
                    <div className="wide">
                    <div className="checkoutLine t1">
                            <div className="body1 grey1">Shipping address</div>
                        <div className="flexEnd">
                        <div className="body1 grey1">{props.userPack.elements.order.deliveryMethod.value===0?"Free":"$"+props.userPack.elements.order.deliveryMethod.value}</div>
                        </div>
                    </div>
                    </div>

                    <div className="wide">
                    <div className="checkoutLine t4">
                            <div className="title3">Order total</div>
                        <div className="flexEnd">
                        <div className="body1 bold">${Math.round((props.userPack.elements.order.deliveryMethod.value+34.99*props.userPack.elements.order.selectionList[0].quantity) * 100) / 100}</div>
                        </div>
                    </div>
                    </div>



            </div>
        </div>
        {props.userPack.dimensions.width<769?<>
            <div className="wide t4" style={{position:"fixed",bottom:"0px",width:"100vw" }}>
                       <div className="wide alignCenter" style={{height:"70px",width:"100%", backgroundColor:"white"}}>
                        <Button text="Confirm and pay" action={checkout}/>
                        </div>
                    </div>
        </>:null}

        {props.userPack.dimensions.width>750?<>
            <div className="wide t4" style={{position:"fixed",bottom:"0px",width:"100vw"}}>
                       <div className="wide alignCenter" style={{height:"70px",width:"100%", backgroundColor:"white"}}>
                        <Button text="Confirm and pay" action={checkout} style="4"/>
                        </div>
                    </div>
        </>:null}
        </>
    )
}

class Checkout extends Component {
    constructor(props){
        super(props);
    }
    state={tabs:this.props.tabs,step:1}
    componentDidMount(prevProps){
        const location =  window.location.href
        if(location.includes(this.state.tabs[0])){
            this.setState({step:1})
        }else if(location.includes(this.state.tabs[1])){
            //
            this.setState({step:2})
        }else if(location.includes(this.state.tabs[2])){
            //
            this.setState({step:3})
        }
    }
    nextStep=(e)=>{
        try {
            e.preventDefault()
            e.stopPropagation()
        } catch (error) {
            
        }
        let newStep={...this.state.step}+1
        this.setState({step:newStep})
        return
    }
    setStepFunction=(e)=>{
        this.setState({step:e})
        return
    }
    previousStep=(e)=>{
        try {
            e.preventDefault()
            e.stopPropagation()
        } catch (error) {
            
        }
        let newStep={...this.state.step}-1
        this.setState({step:newStep})
        return
    }
    render() { 
        return ( 
            <>
            <StepInfo elements={this.props.elements} stripe={this.props.stripe} tabs={this.state.tabs} userPack={this.props.userPack} step={this.state.step} nextStep={this.nextStep} setStep={this.setStepFunction}/>
         </>
         );
    }
}
 
export default Checkout;

   